import { useSpinner } from '@components/SpinnerContext';

function Spinner() {

  const { loading } = useSpinner();

  if (!loading) return null;

  return (
    <div id="spinner">
      <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
  );
};

export default Spinner;